import { RowDataDealer } from "../../components/DealerPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the DealerTable factory
 */
class DealerRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/dealer/read-range"
        this.accessData = "dealer"
    }

    create(dealer: any): RowDataDealer {
        const rowDataOrder: RowDataDealer = {
            uid: dealer.uid,
            fullname: dealer.fullname,
            phone_number: dealer.phone_number,
            email: dealer.email,
            dob: dealer.dob,
            company: dealer.company,
            ssm_document: dealer.ssm_document,
            action: "",

            nric_fullname: dealer.nric_fullname,
            nric: dealer.nric,
            tin: dealer.tin,
            address_line_1: dealer.address_line_1,
            address_line_2: dealer.address_line_2,
            postal: dealer.postal,
            city: dealer.city,
            state: dealer.state,
            country: dealer.country,
            business_phone_number: dealer.business_phone_number,
            sst_registration_number: dealer.sst_registration_number,
            nricImg: dealer.nricImg,

            isVerified: dealer.isVerified,

            createdAt: dealer.createdAt,

            ssm_number: dealer.ssm_number,
            msic: dealer.msic,
            submittedAt: dealer.submittedAt,
        };
        return rowDataOrder;
    }

    generateParams(params: any, extra: any) {
        params["new"] = extra.current
        return params
    }
}

let dealerRow: DealerRow | null = null;

export default function getDealerRow(): DealerRow {
    if (dealerRow === null)
        dealerRow = new DealerRow()
    return dealerRow
}